import React from "react"
import "./OurHistory.css"
import { getNotableMembers } from "../../util/Member_Query";
import MemberCard from "../../components/member_card/Member_Card";
import MindpunchSite from "../../img/Screenshots/Mindpunch Site.png";
function OurHistory() { 
    
    var notableMembers  =  getNotableMembers();

    // console.log(members);
    return(
    <div className="Our-History-Parent-Container">
        <div className="Our-History-Child-Container">

            <div className="breakout-0">
                <div className="Page-Width">
                    <h1 className="Title"> 
                        Our History 
                    </h1>
                    
                    <h2 className="SubTitle">
                        Origins
                    </h2>
                    <p className="body">
                    The Mindpunch Server was created by a Minecraft player named MrPiggyWinkles52 (Piggy) with the help of friends JackStarBurst and BaneSlayar/awe989 in January of that year. The server has evolved immensely over time, with over 100 players coming and going throughout the years, and notable people making significant impacts in the community. Originally inspired by Mindcrack SMP, the Mindpunch server has upheld its roots as a strictly survival server for over 10 years and is now entering its 14th season. The name Mindpunch was created by combining two inspirations for the server: Mindcrack and Punchwood. In fact, the server was originally founded on the Punchwood Forums. Being a tight-knit group remains at the heart of the community, with bonds of friendship formed across continents that stand the test of time. The fundamental aspect of server decisions being made by the community has also remained a pivotal foundation of the server.
                    </p>
                </div>

            </div> {/* END OF BREAKOUT-O*/ }   


            <div className="breakout-1">
                <div className="Page-Width">
                    <div className="breakout-1-child">
                        <div clasNamme="breakout-text">
                            <h2 className="SubTitle">
                                Our Home
                            </h2>

                            <p className="body">
                                The original home of the Mindpunch community was on the Punchwood Forums, where an individual thread held hundreds of pages of communications between members. Managing communications on this became unfeasible, leading to the server's move to its own site, mindpunch.enjin.com, by mid-2013. Although the Mindpunch forums were around for a long time, they were eventually taken down in late 2023. Despite this, the forums ceased to be actively used by late 2016 when server activity had declined. This situation persisted until May 2, 2017, when Tvindy brought the gang together over a Skype chat, which became the home of 16 Mindpunch members until Zapwad created a Discord server in January 2018, which is still used to this day.
                            </p>
                        </div>


                        <img className="breakout-img" src={MindpunchSite} alt="Screeshot describing the history of early Mindpunch Seasons from Piggy on the Mindpunch Site"/>
                    </div>
                </div>
            </div> {/*END OF BREAKOUT-!*/}
    
            <div className="breakout-2">
                <div className="Page-Width">
                    <h2 className="SubTitle">
                        Leadership
                    </h2>
                    <p className="body">
                        Whilst Piggy led the server for the first few years, we experienced a lul inbetween 2016 and 2017 in which Tvindy picked up the reigns on May 2nd 2017 and has held them ever since.
                    </p>


                </div>
            </div> {/*END OF breakout-2*/}
            
    
            <div className="Members-Parent-History Page-Width">
                <div className="Members Page-Width">
                    <h2 className="SubTitle">
                        Notable Members (in no particular order)
                    </h2>
                    { notableMembers.map((member) => (
                        <div className="Member-Container">
                            <MemberCard member={member} />
                            <p className="Member-Description">{member['notability']} </p>
                        </div> 
                        ))
                            

                        }
                </div>
            </div>
        
        </div>    
    </div>
)
}

export default OurHistory;